import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {red500, red800} from 'material-ui/styles/colors';
import { TopToolbar, BottomToolbar } from './SlideShowTools';

import * as firebase from 'firebase';

const SHOW_WARNING = 'showWarning';
const CLOSE_WARNING = 'closeWarning';
const DELETE_IMAGE = 'deleteImage';

class SlideShow extends Component {

  transitionStyles = {
    entering: {opacity: 1, backgroundColor: 'rgba(0,0,0,0.5)'},
    entered: {opacity: 1, backgroundColor: 'rgba(0,0,0,0.5)'},
  }

  constructor(props){
    super(props)
    this.state={
      toolbarVisible: false,
      fullscreenVisible: false,
      warningModalVisible: false,
      photos : [],
      imageUrls: {},
      currentIndex: props.index
    }
  }

  componentWillReceiveProps(nextProps){

    if (!nextProps.visible){
      return //modal not shown
    } else if (!this.props.visible && nextProps.visible){
      this.setupFullScreen(nextProps)
      this.preparePhotos(this.props.photos, nextProps.photos, false)
    } else {
      this.preparePhotos(this.props.photos, nextProps.photos, true)
    }
  }

  setupFullScreen = (props) => {
    this.setState({
      fullscreenVisible: props.visible,
      currentIndex: props.index,
      toolbarVisible: false,
      warningModalVisible: false
    })
  }

  preparePhotos = (oldPhotos, newPhotos, recalculateCurrentIndex) => {

    if (newPhotos.length === 0){
      this.onCloseFullScreen()
      return
    }

    const newState = {}
    if (recalculateCurrentIndex){
      let { currentIndex } = this.state
      const currentAsset = oldPhotos[currentIndex]
      let newIndex = newPhotos.findIndex(img => img.dbKey === currentAsset.dbKey)

      //check for img deleted
      if (newIndex === -1 && currentIndex === 0) {
        newIndex = 0
      } else if (newIndex === -1){
        newIndex = currentIndex - 1
      }
      newState['currentIndex'] = newIndex
    }
    
    newState['photos'] = newPhotos

    this.setState(newState)

    newPhotos.forEach( (photo, idx) => {
      firebase
      .storage()
      .ref()
      .child(photo.dbPath)
      .getDownloadURL()
      .then(imageUrl => {
          let { imageUrls } = this.state
          imageUrls = Object.assign({}, imageUrls, {[photo.dbPath]: imageUrl})
          this.setState({ imageUrls })
      })
    })
  }

  onCloseFullScreen = () => {
    this.setState({ fullscreenVisible: false })
    this.props.onClose()
  }

  photoActions(action){
    switch(action){
      case SHOW_WARNING:
        this.setState({warningModalVisible: true});
        break;
      case CLOSE_WARNING:
        this.setState({warningModalVisible: false});
        break;
      case DELETE_IMAGE: {
        const { currentIndex, photos } = this.state
        const currentAsset = photos[currentIndex]
        const path = `${this.props.photosListDbPath}/${currentAsset.dbKey}/delete`
        this.setState({warningModalVisible: false});
        const update = {}
        update[path] = true;
        firebase.database().ref().update(update);
        break;
      }
    }
  }

  returnDeleteActionsElements = () => {
    return [ <FlatButton
              key='cancel'
              label="Cancel"
              primary={true}
              onClick={this.photoActions.bind(this, CLOSE_WARNING)} />,
             <FlatButton
              key='delete'
              label="Delete"
              disableTouchRipple={false}
              primary={true}
              backgroundColor={red500}
              labelStyle={{color: 'white'}}
              hoverColor={red800}
              onClick={this.photoActions.bind(this, DELETE_IMAGE)} />
            ];
  }

  incrementIndex = () => {
    let { currentIndex, photos } = this.state
    if (currentIndex < photos.length - 1){
      currentIndex++
    }
    this.setState({ currentIndex })
  }

  decrementIndex = () => {
    let { currentIndex, photos } = this.state
    if (currentIndex > 0){
      currentIndex--
    }
    this.setState({ currentIndex })
  }

  render() {
    const { currentIndex, photos, imageUrls, fullscreenVisible } = this.state

    if (!fullscreenVisible || photos.length < 1){
      return null
    }

    const currentAsset = photos[currentIndex]
    const imageUrl = imageUrls[currentAsset.dbPath]
    const deleteWarningActions = this.returnDeleteActionsElements()
    return (
      <Dialog
        open={this.state.fullscreenVisible}
        bodyStyle={{ padding: 0 }}
        contentStyle={styles.contentStyle}
        autoScrollBodyContent={true}
        onRequestClose={this.onCloseFullScreen}>

        <div
          style={styles.container}
          onMouseEnter={() => this.setState({toolbarVisible: true})}
          onMouseLeave={() => this.setState({toolbarVisible: false})}>

          <TopToolbar
            toolbarVisible={this.state.toolbarVisible}
            onClose={this.onCloseFullScreen}
            onDelete={this.photoActions.bind(this, SHOW_WARNING)}/>

          <div
            style={styles.imageContainer}>
            {imageUrl
             &&
             <img
              style={styles.image}
              src={imageUrl}/>
            }
          </div>

          <BottomToolbar
            toolbarVisible={this.state.toolbarVisible}
            onLeftArrow={this.decrementIndex}
            onRightArrow={this.incrementIndex}
            />
        </div>

        <Dialog
          open={this.state.warningModalVisible}
          actions={deleteWarningActions}
          contentStyle={styles.warningContainer}
          onRequestClose={this.photoActions.bind(this, CLOSE_WARNING)}>
          <div>This photo will not be available any longer after deletion.</div>
        </Dialog>

      </Dialog>
    )
  }

}

const styles = {
  contentStyle: {
    display:'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    padding: 0,
  },
  container: {
    width: 600,
    height: 400,
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'white'
  },
  imageContainer: {
    display: 'block',
    flexDirection:'row',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  image: {
    display: 'block',
    width: 'auto',
    maxWidth: 600,
    maxHeight: 400,
  },
  warningContainer: {
    display: 'block',
    width: 'auto',
    maxWidth: 600,
    maxHeight: 400,
  }

}

export default SlideShow;



// WEBPACK FOOTER //
// ./src/common/PhotoSlideShow/SlideShow.js